import { transformDestinationEvent } from '@eventbrite/event-renderer';
import { deepKeysToCamel } from '@eventbrite/transformation-utils';

export const getTrendingTagEvents = async (
    category: string,
    placeId: string,
) => {
    try {
        const response = await fetch(
            `/curation-ai/events?category=${category}&placeId=${placeId}`,
        );
        if (!response.ok) {
            throw new Error(
                `Network response was not ok. Status code: ${response.status}, URL: ${response.url}`,
            );
        }
        const responseData = await response.json();
        if (!Array.isArray(responseData)) {
            throw new Error('Response data is not an array');
        }
        const transformedData = responseData.map((item) => ({
            ...item,
            events: item.events.map((event: any) => {
                const transformedEvent = transformDestinationEvent(event);
                const eventDetails = event.enrichment;
                return {
                    ...transformedEvent,
                    imageUrl: eventDetails?.image?.url || '',
                    venue: deepKeysToCamel(eventDetails?.venue),
                    isFree: eventDetails?.tickets?.is_free,
                    minPrice: {
                        currency:
                            eventDetails?.tickets?.minimum_ticket_price
                                ?.currency || '',
                        minPriceValue:
                            eventDetails?.tickets?.minimum_ticket_price?.value,
                    },
                    maxPrice: {
                        currency:
                            eventDetails?.tickets?.maximum_ticket_price
                                ?.currency || '',
                        maxPriceValue:
                            eventDetails?.tickets?.maximum_ticket_price?.value,
                    },
                    eventSalesStatus: {
                        message: eventDetails?.sales_status || '',
                    },
                    urgencySignals: {},
                };
            }),
        }));
        return transformedData || [];
    } catch (error) {
        console.error('Error fetching trending tag events', error);
    }
};
